export const SellAndRentStatus = {
  WAITING_FOR_AUTHORITY: "อยู่ในระหว่างเจ้าหน้าที่ติดต่อกลับ",
  LOOKING_FOR_RENTERS: "ดำเนินการหาผู้ซื้อและ (หรือ) ผู้เช่า",
  COMPLETED: "ขาย หรือ ปล่อยเช่า เรียบร้อย",
  CANCELLED: "รายการถูกยกเลิก เนื่องจากลูกค้าแก้ไขข้อมูล"
};

export const SellAndRentStatusEnum = {
  WAITING_FOR_AUTHORITY: "WAITING_FOR_AUTHORITY",
  LOOKING_FOR_RENTERS: "LOOKING_FOR_RENTERS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};



// WEBPACK FOOTER //
// ./src/features/sell-and-rent/SellAndRentStatus.js